module.exports = __webpack_public_path__ + "static/media/5.cf0dc6f0.JPG";